// ابزارهای نمایش اعداد فارسی — ارقام فارسی با جداکننده + عدد به حروف

export const toPersianDigitsStr = (s: string | number): string =>
  String(s).replace(/[0-9]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[Number(d)]);

/** «12345678» → «۱۲٬۳۴۵٬۶۷۸» (برای نمایش داخل input های مبلغ) */
export const formatPersianMoneyInput = (val: string | number): string => {
  const s = String(val ?? '').replace(/[٬,]/g, '').replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d))).replace(/[^\d]/g, '');
  if (!s) return '';
  return toPersianDigitsStr(s.replace(/\B(?=(\d{3})+(?!\d))/g, '٬'));
};

/** ورودی کاربر (فارسی/لاتین با جداکننده) → رشتهٔ رقم لاتین خالص */
export const parsePersianMoneyInput = (val: string): string =>
  val
    .replace(/[٬,]/g, '')
    .replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
    .replace(/[^\d]/g, '');

const ONES = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'];
const TEENS = ['ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده'];
const TENS = ['', '', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
const HUNDREDS = ['', 'صد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'];
const SCALES = ['', 'هزار', 'میلیون', 'میلیارد', 'هزار میلیارد'];

const threeDigitsToWords = (n: number): string => {
  const parts: string[] = [];
  const h = Math.floor(n / 100);
  const rest = n % 100;
  if (h) parts.push(HUNDREDS[h]);
  if (rest >= 10 && rest < 20) {
    parts.push(TEENS[rest - 10]);
  } else {
    const t = Math.floor(rest / 10);
    const o = rest % 10;
    if (t) parts.push(TENS[t]);
    if (o) parts.push(ONES[o]);
  }
  return parts.join(' و ');
};

/** 20000000 → «بیست میلیون» */
export const numberToPersianWords = (n: number): string => {
  if (!Number.isFinite(n)) return '';
  const int = Math.floor(Math.abs(n));
  if (int === 0) return 'صفر';
  const groups: number[] = [];
  let x = int;
  while (x > 0) {
    groups.push(x % 1000);
    x = Math.floor(x / 1000);
  }
  const parts: string[] = [];
  for (let i = groups.length - 1; i >= 0; i--) {
    const g = groups[i];
    if (!g) continue;
    const words = threeDigitsToWords(g);
    const scale = SCALES[i] || '';
    parts.push(scale ? `${words} ${scale}` : words);
  }
  return (n < 0 ? 'منفی ' : '') + parts.join(' و ');
};

/** 20000000 → «بیست میلیون تومان» — کپشن زیر فیلدهای مبلغ */
export const amountToPersianWords = (n: number): string =>
  n > 0 ? `${numberToPersianWords(n)} تومان` : '';
